module.exports = __webpack_public_path__ + "img/btn-intro.82ebe145.png";